import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { Breadcrumbs, Item } from '@snack-uikit/breadcrumbs';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import { ReactNode, useMemo } from 'react';

import { BlogRichText } from '../../helperComponents';
import styles from './styles.module.scss';
import { getTitleTypographyProps } from './utils';

type SectionArticleProps = WithLayoutType<{
  id?: string;
  className?: string;
  breadcrumbs: Item[];
  title: string;
  description: string;
  children: ReactNode;
}>;

export function SectionArticle(props: SectionArticleProps) {
  const {
    id,
    className,
    layoutType,
    breadcrumbs,
    title,
    description,
    children,
  } = props;

  const titleProps = useMemo(
    () => getTitleTypographyProps(layoutType),
    [layoutType],
  );

  return (
    <section
      id={id}
      className={cn(styles.sectionWrapper, className)}
      data-test-id="section-article"
    >
      <div className={styles.sectionArticle} data-layout-type={layoutType}>
        <div className={styles.header}>
          <Breadcrumbs items={breadcrumbs} />
          <div className={styles.sectionTitle}>
            <Typography
              family="sans"
              {...titleProps}
              className={styles.title}
              tag="h1"
              data-test-id="article-title"
            >
              {title}
            </Typography>
            <Typography.SansBodyL
              className={styles.description}
              tag="div"
              data-test-id="article-description"
            >
              <BlogRichText layoutType={layoutType} richText={description} />
            </Typography.SansBodyL>
          </div>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </section>
  );
}
